import { Menu, X } from 'lucide-react';
import { Button } from "./ui/button";
import { EnrollmentModal } from "./EnrollmentModal";
import { useState } from 'react';
import logocolorImage from './../styles/eyeslkm_color_logo.png';

interface HeaderProps {
  currentPage?: string;
  onNavigate?: (page: string) => void;
}

export function Header({ currentPage = 'home', onNavigate }: HeaderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isEnrollmentModalOpen, setIsEnrollmentModalOpen] = useState(false);

  const handleNavClick = (page: string) => {
    if (onNavigate) {
      onNavigate(page);
    }
    setIsMobileMenuOpen(false); // Close mobile menu when navigating
  };

  const handleEnrollClick = () => {
    setIsEnrollmentModalOpen(true);
    setIsMobileMenuOpen(false); // Close mobile menu if open
  };

  const navItems = [
    { name: 'Home', key: 'home' },
    { name: 'About', key: 'about' },
    { name: 'Programs', key: 'programs' },
    { name: 'Gallery', key: 'gallery' },
    { name: 'Contact', key: 'contact' }
  ];

  return (
    <>
      <header className="w-full bg-white shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 py-2">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center cursor-pointer" onClick={() => handleNavClick('home')}>
              <img 
                src={logocolorImage} 
                alt="Eyes of a Child - LKM" 
                className="h-12 w-auto object-contain"
              />
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              {navItems.map((item) => (
                <button
                  key={item.key}
                  onClick={() => handleNavClick(item.key)}
                  className={`transition-colors ${
                    currentPage === item.key 
                      ? "text-orange-400 font-medium" 
                      : "text-gray-700 hover:text-orange-400"
                  }`}
                >
                  {item.name}
                </button>
              ))}
            </nav>

            {/* CTA Button */}
            <div className="hidden md:block">
              <Button 
                className="bg-orange-400 hover:bg-orange-500 text-white px-6 py-2 rounded-full"
                onClick={handleEnrollClick}
              >
                Enroll Now
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <Button 
              variant="ghost" 
              size="icon" 
              className="md:hidden"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="md:hidden mt-4 pb-4 border-t border-gray-200">
              <nav className="flex flex-col space-y-4 pt-4">
                {navItems.map((item) => (
                  <button
                    key={item.key}
                    onClick={() => handleNavClick(item.key)}
                    className={`text-left transition-colors ${
                      currentPage === item.key 
                        ? "text-orange-400 font-medium" 
                        : "text-gray-700 hover:text-orange-400"
                    }`}
                  >
                    {item.name}
                  </button>
                ))}
                <Button 
                  className="bg-orange-400 hover:bg-orange-500 text-white px-6 py-2 rounded-full w-full mt-4"
                  onClick={handleEnrollClick}
                >
                  Enroll Now
                </Button>
              </nav>
            </div>
          )}
        </div>
      </header>
      
      <EnrollmentModal 
        isOpen={isEnrollmentModalOpen} 
        onClose={() => setIsEnrollmentModalOpen(false)} 
      />
    </>
  );
}